export const SEARCH_DEBOUNCE_TIME = 1000;
export const MIN_SEARCH_LENGTH = 3;
